// 拜访记录
import {dynamicPropsFn} from './util.js'
const WgVisitRecordList = resolve => require(['@/views/WgVisitRecord/List'], resolve)
const WgVisitRecordDetail = resolve => require(['@/views/WgVisitRecord/Detail'], resolve)
const WgVisitRecordNew = resolve => require(['@/views/WgVisitRecord/New'], resolve)
const WgVisitRecordEdit = resolve => require(['@/views/WgVisitRecord/Edit'], resolve)

export default [
  {
    name: 'WgVisitRecord_List',
    path: '/WgVisitRecord/list',
    component: WgVisitRecordList,
    meta: {
      keepAlive: false,
      title: '拜访记录列表',
    },
  },
  {
    name: 'WgVisitRecord_detail',
    path: '/WgVisitRecord/detail',
    component: WgVisitRecordDetail,
    meta: {
      keepAlive: false,
      title: '拜访记录详情',
    },
  },
  {
    name: 'WgVisitRecord_new',
    path: '/WgVisitRecord/new',
    component: WgVisitRecordNew,
    meta: {
      keepAlive: false,
      title: '新建拜访记录',
    },
  },
  {
    name: 'WgVisitRecord_edit',
    path: '/WgVisitRecord/edit',
    component: WgVisitRecordEdit,
    props: dynamicPropsFn,
    meta: {
      keepAlive: false,
      title: '编辑拜访记录',
    },
  },

]



// WEBPACK FOOTER //
// ./src/router/wgVisitRecord.js